import { Theme, createStyles, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    alignRight: {
      textAlign: "right",
    },
    marginTop: {
      marginTop: theme.spacing(2),
    },
  }),
);

export default useStyles;
